import { getServerApi } from '@/gql';
import { Adventure } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import moment from 'moment';
import { useEffect, useState } from 'react';
export interface UseAdventuresResult {
    adventures: Adventure[];
    loading: boolean;
    error: Error | null;
    getAdventures: (date?: Date) => Promise<Adventure[]>;
}

export const useAdventures = (tokenId: number): UseAdventuresResult => {
    const [adventures, setAdventures] = useState<Adventure[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getAdventures = async (date?: Date) => {
        if (!tokenId || !userId || !date) {
            setAdventures([]);
            return [];
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.adventures({
                tokenId: tokenId,
                pageNum: 1,
                pageSize: 20,
                date: moment(date ?? new Date()).format('YYYY-MM-DD'),
            });
            if (response?.adventures !== undefined) {
                setAdventures(response.adventures);
                return response.adventures;
            } else {
                setAdventures([]);
                return [];
            }
        } catch (err) {
            console.error('Failed to fetch adventures:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch adventures'),
            );
            setAdventures([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAdventures();
    }, [tokenId, userId]);

    return {
        adventures,
        loading,
        error,
        getAdventures,
    };
};
